import _styled from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import isEmpty from "lodash-es/isEmpty";
import { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import ReactSelect from "react-select";
import styled from "styled-components";
import ErrorComponent from "./ErrorComponent";
import Loading from "./Loading";
import Text from "../../../Styled/Text";
import Box from "../../../Styled/Box";
import Button from "../../../Styled/Button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SearchForm = props => {
  const {
    parameters,
    itemSearchProvider
  } = props;
  const [t] = useTranslation();
  const [state, setState] = useState({
    is: "initial"
  });
  const [query, setQuery] = useState(props.query);
  useEffect(function setValuesFromProps() {
    setQuery(props.query);
  }, [props.query]);
  const setParameterValue = (id, type) => value => {
    var _props$onValueChange;
    const newQuery = _objectSpread(_objectSpread({}, query), {}, {
      [id]: {
        type,
        value
      }
    });
    // Delete the value so that we don't trigger search for it
    if (newQuery[id].value === undefined) delete newQuery[id];
    setQuery(newQuery);
    if (value !== undefined) (_props$onValueChange = props.onValueChange) === null || _props$onValueChange === void 0 || _props$onValueChange.call(props, id, value);
  };
  function search() {
    const parameterValues = new Map(Object.entries(query).map(_ref => {
      let [id, {
        value
      }] = _ref;
      return [id, value];
    }));
    setState({
      is: "searching"
    });
    itemSearchProvider.search(parameterValues).then(results => {
      setState({
        is: "results",
        results
      });
      props.onResults(query, results);
    }).catch(error => {
      console.warn(error);
      setState({
        is: "error",
        error
      });
    });
  }
  const onSubmit = e => {
    try {
      search();
    } finally {
      e.preventDefault();
    }
  };
  const clearForm = () => setQuery({});
  const disabled = state.is === "searching";
  return /*#__PURE__*/_jsxs(Form, {
    onSubmit: onSubmit,
    children: [/*#__PURE__*/_jsxs(Box, {
      centered: true,
      children: [state.is === "searching" && /*#__PURE__*/_jsx(Loading, {
        children: t("itemSearchTool.searching")
      }), state.is === "error" && /*#__PURE__*/_jsx(ErrorComponent, {
        children: t("itemSearchTool.searchError")
      })]
    }), /*#__PURE__*/_jsxs(FieldSet, {
      disabled: disabled,
      children: [parameters.map(p => {
        var _query$p$id;
        return /*#__PURE__*/_jsx(Field, {
          children: /*#__PURE__*/_jsx(Parameter, {
            parameter: p,
            onChange: setParameterValue(p.id, p.type),
            value: (_query$p$id = query[p.id]) === null || _query$p$id === void 0 ? void 0 : _query$p$id.value,
            disabled: disabled,
            t: t
          })
        }, p.id);
      }), /*#__PURE__*/_jsx(SearchButton, {
        primary: true,
        type: "submit",
        disabled: disabled,
        children: t("itemSearchTool.searchBtnText")
      }), /*#__PURE__*/_jsx(Button, {
        secondary: true,
        type: "reset",
        onClick: clearForm,
        disabled: disabled,
        children: t("itemSearchTool.resetBtnText")
      })]
    })]
  });
};
const Parameter = props => {
  const {
    parameter
  } = props;
  switch (parameter.type) {
    case "numeric":
      return /*#__PURE__*/_jsx(NumericParameter, _objectSpread(_objectSpread({}, props), {}, {
        parameter: parameter
      }));
    case "enum":
      return /*#__PURE__*/_jsx(EnumParameter, _objectSpread(_objectSpread({}, props), {}, {
        parameter: parameter
      }));
    case "text":
      return /*#__PURE__*/_jsx(TextParameter, _objectSpread(_objectSpread({}, props), {}, {
        parameter: parameter
      }));
  }
};
export const NumericParameter = props => {
  var _value$start, _value$end;
  const {
    parameter,
    value,
    t
  } = props;
  const {
    min,
    max
  } = parameter.range;
  const onChange = tag => e => {
    const parsed = parseFloat(e.target.value);
    const newValue = _objectSpread({}, props.value);
    if (isNaN(parsed)) delete newValue[tag];else newValue[tag] = parsed;
    props.onChange(isEmpty(newValue) ? undefined : newValue);
  };
  return /*#__PURE__*/_jsxs(Box, {
    column: true,
    children: [/*#__PURE__*/_jsx(ParameterName, {
      children: parameter.name
    }), /*#__PURE__*/_jsxs(_StyledBox, {
      children: [/*#__PURE__*/_jsx(HalfWidthLabel, {
        children: /*#__PURE__*/_jsxs(Box, {
          column: true,
          children: [/*#__PURE__*/_jsx(Text, {
            small: true,
            children: t("itemSearchTool.numericParameter.minimum")
          }), /*#__PURE__*/_jsx(Input, {
            type: "number",
            name: "".concat(parameter.id, "-min"),
            value: (_value$start = value === null || value === void 0 ? void 0 : value.start) !== null && _value$start !== void 0 ? _value$start : "",
            min: min,
            max: max,
            step: "any",
            placeholder: min.toString(),
            onChange: onChange("start")
          })]
        })
      }), /*#__PURE__*/_jsx(HalfWidthLabel, {
        children: /*#__PURE__*/_jsxs(Box, {
          column: true,
          children: [/*#__PURE__*/_jsx(Text, {
            small: true,
            children: t("itemSearchTool.numericParameter.maximum")
          }), /*#__PURE__*/_jsx(Input, {
            type: "number",
            name: "".concat(parameter.id, "-max"),
            value: (_value$end = value === null || value === void 0 ? void 0 : value.end) !== null && _value$end !== void 0 ? _value$end : "",
            min: min,
            max: max,
            step: "any",
            placeholder: max.toString(),
            onChange: onChange("end")
          })]
        })
      })]
    })]
  });
};
const EnumParameter = props => {
  const {
    parameter,
    disabled
  } = props;
  const options = parameter.values.map(_ref2 => {
    let {
      id
    } = _ref2;
    return {
      value: id,
      label: id || "<empty>"
    };
  });
  const value = options.filter(o => {
    var _props$value;
    return (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.includes(o.value);
  });
  const onChange = selectedOptions => {
    const values = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(_ref3 => {
      let {
        value
      } = _ref3;
      return value;
    });
    props.onChange((values === null || values === void 0 ? void 0 : values.length) === 0 ? undefined : values);
  };
  return /*#__PURE__*/_jsx(Box, {
    column: true,
    children: /*#__PURE__*/_jsxs(Label, {
      children: [/*#__PURE__*/_jsx(ParameterName, {
        children: parameter.name
      }), /*#__PURE__*/_jsx(Select, {
        name: parameter.id,
        options: options,
        isMulti: true,
        value: value,
        menuPosition: "fixed",
        onChange: onChange,
        isDisabled: disabled
      })]
    })
  });
};
const TextParameter = props => {
  const {
    parameter,
    value,
    onChange
  } = props;
  return /*#__PURE__*/_jsx(Box, {
    column: true,
    children: /*#__PURE__*/_jsxs(Label, {
      children: [/*#__PURE__*/_jsx(ParameterName, {
        children: parameter.name
      }), /*#__PURE__*/_jsx(Input, {
        type: "text",
        name: parameter.id,
        value: value || "",
        onChange: e => onChange(e.target.value ? e.target.value : undefined)
      })]
    })
  });
};
const Form = styled.form.withConfig({
  displayName: "SearchForm__Form",
  componentId: "sc-1vi7mg7-0"
})(["width:100%;"]);
export const FieldSet = styled.fieldset.withConfig({
  displayName: "SearchForm__FieldSet",
  componentId: "sc-1vi7mg7-1"
})(["border:0;margin:0;padding:0;min-width:0;"]);
export const SearchButton = styled(Button).withConfig({
  displayName: "SearchForm__SearchButton",
  componentId: "sc-1vi7mg7-2"
})(["margin:10px 10px 0 0;"]);
const Field = styled(Box).attrs({
  column: true,
  paddedVertically: true
}).withConfig({
  displayName: "SearchForm__Field",
  componentId: "sc-1vi7mg7-3"
})([""]);
const ParameterName = styled(Text).attrs({
  semiBold: true,
  breakWord: true
}).withConfig({
  displayName: "SearchForm__ParameterName",
  componentId: "sc-1vi7mg7-4"
})([""]);
const Label = styled.label.withConfig({
  displayName: "SearchForm__Label",
  componentId: "sc-1vi7mg7-5"
})([""]);
const HalfWidthLabel = styled(Label).withConfig({
  displayName: "SearchForm__HalfWidthLabel",
  componentId: "sc-1vi7mg7-6"
})(["width:45%;&:first-child{margin-right:1em;}"]);
const Input = styled.input.withConfig({
  displayName: "SearchForm__Input",
  componentId: "sc-1vi7mg7-7"
})(["color:", ";box-sizing:border-box;width:100%;height:38px;font-size:1.1em;"], p => p.theme.dark);
const Select = styled(ReactSelect).attrs({
  classNamePrefix: "ReactSelect"
}).withConfig({
  displayName: "SearchForm__Select",
  componentId: "sc-1vi7mg7-8"
})(["color:", ";width:100%;& .ReactSelect__control{border-radius:0;}"], p => p.theme.dark);
export default withTranslation()(SearchForm);
var _StyledBox = styled(Box).withConfig({
  displayName: "SearchForm___StyledBox",
  componentId: "sc-1vi7mg7-9"
})(["justify-content:space-between;"]);